'use client'

import StatCards from './StatCards'
import { formatFontFamily } from '@/lib/themeHelpers'

interface HeroSectionProps {
  theme: any;
  radius: number;
  fontFamily: string;
  imageUrl: string;
  content: any;
}

export default function HeroSection({
  theme,
  radius,
  fontFamily,
  imageUrl,
  content
}: HeroSectionProps) {
  return (
    <section 
      className="relative isolate overflow-hidden min-h-screen" 
      style={{ 
        background: '#FFFFFF',
        fontFamily: formatFontFamily(fontFamily)
      }}
    >
      {/* 2-Column Layout */}
      <div className="mx-auto max-w-6xl px-6 pt-6 pb-24 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center min-h-[80vh]">
          
          {/* Left Column - Content */}
          <div className="text-left">
            <div style={{
              display: 'inline-flex',
              background: 'linear-gradient(90deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)',
              color: theme.text,
              padding: '8px 16px',
              borderRadius: radius,
              fontSize: '14px',
              fontWeight: '300',
              letterSpacing: '2%',
              marginBottom: '24px',
              fontFamily: formatFontFamily(fontFamily),
              alignItems: 'center',
              gap: '8px',
              width: 'fit-content',
              border: `1px solid ${theme.border}`
            }}>
              {content.tag}
            </div>
            <h1 className="mt-6 text-4xl font-semibold leading-tight md:text-5xl lg:text-6xl font-primary" style={{ color: theme.accent }}>
              {content.title}
            </h1>
            <p className="mt-6 text-lg leading-relaxed font-primary" style={{ color: theme.mutedText }}>
              {content.description}
            </p>
            <div className="mt-10">
              <StatCards theme={theme} radius={radius} stats={content.stats} />
            </div>
            <div className="mt-8">
              <button 
                className="px-4 py-2 text-sm font-medium shadow-sm font-primary" 
                style={{ 
                  backgroundColor: theme.button, 
                  color: theme.onButton, 
                  borderRadius: radius
                }}
                onClick={() => (window as any).ChatWidget?.showChat()}
              >
                {content.ctaText}
              </button>
            </div>
          </div>

          {/* Right Column - Image */}
          <div className="relative">
            <div 
              className="w-full h-[500px] lg:h-[600px] rounded-lg shadow-2xl"
              style={{
                backgroundImage: `url(${imageUrl})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                borderRadius: radius
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
